import React, { useCallback } from "react";
import { StyleSheet, View, FlatList } from "react-native";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import t from "@constants/localization";
import { useDispatch, useSelector } from "react-redux";
import { SummaryTransaction } from "./responseInterfaces";
import WalletFilters from "./components/WalletFilter";
import { actions as walletActions } from "@reducers/walletReducer";
import { useFocusEffect } from "@react-navigation/native";
import AggHeaderCard from "./components/AggHeaderCard";
import AggTransactionCard from "./components/AggTransactionCard";
import SkeletonLoaderList from "@components/SkeletonLoaderList";

const PATH = "screens/Wallet/Landing";

interface AggTransactionsViewProps {
  navigation: any;
  route: any;
}

const AggTransactionsView: React.FC<AggTransactionsViewProps> = ({
  navigation,
  route,
}) => {
  const dispatch = useDispatch();
  const { walletSummary, isLoading } = useSelector(
    (state) => state.walletReducer,
  );
  const { transactionType } = route?.params || {};

  useFocusEffect(
    useCallback(() => {
      dispatch(walletActions.setWalletTxnType(transactionType));
      dispatch(walletActions.getWalletSummary());
    }, [dispatch]),
  );
  const handlePressListItem = (item: SummaryTransaction) => {
    if (item.nav_to === "AGG") {
      dispatch(walletActions.setWalletTxnType(item.key));
      navigation.push("AggTransactionsView", { transactionType: item.key });
    } else {
      dispatch(walletActions.resetWalletTransactionsData());
      dispatch(walletActions.setTransactionType(item.key));
      navigation.navigate("TransactionsView");
    }
  };

  const renderItem = ({ item }: any) => (
    <AggTransactionCard item={item} onPress={() => handlePressListItem(item)} />
  );

  const handleApplyFilter = () => {
    dispatch(walletActions.getWalletSummary());
  };

  return (
    <>
      <HeaderWithBackAndTitle
        route={route}
        navigation={navigation}
        headertitle={t(`${PATH}/wallet`)}
        subHeaderTitle={undefined}
        headerStyle={undefined}
        rightIcon={undefined}
        RightButton={undefined}
        goingBackHandler={undefined}
        IsRightIconDropDown={undefined}
      />
      {isLoading ? (
        <SkeletonLoaderList length={8} marginHorizontal={16} />
      ) : (
        <View style={styles.container}>
          <AggHeaderCard summary={walletSummary?.summary} />
          <WalletFilters onApplyFilter={handleApplyFilter} />
          <FlatList
            data={walletSummary?.transactions}
            keyExtractor={(item) => item.key}
            renderItem={renderItem}
          />
        </View>
      )}
    </>
  );
};

export default AggTransactionsView;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginVertical: 16,
  },
});
